import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastService } from '../../../main/services';
import {
    Contract, ContractSupplier, Round, Tender
} from '../../models';
import {User} from '../../../auth/models';

@Component({
    selector: 'jft-tender-index-analysis-graph',
    templateUrl: './tender-contract-dashboard-index-analysis-graph.component.html',
    styleUrls: ['./tender-contract-dashboard-index-analysis-graph.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TenderContractDashboardIndexAnalysisGraphComponent implements OnInit {
    public tender: Tender;
    public contract: Contract;
    public offers: ContractSupplier[] = [];
    public rounds: Round[] = [];
    public round: Round;
    public plattsChartIndexes: any = [];

    constructor(
        public user: User,
        private route: ActivatedRoute,
        protected toast: ToastService,
    ) {
    }

    ngOnInit() {
        if (!this.user.settings.platts_subscriber) {
            this.toast.error('Active S&P Global Subscription is required to access this page.<br><br>Go to Settings > <a href="/account/platts" target="_blank">S&P Global</a> to enter API credentials or <a href="/access/contact-support" target="_blank">contact Support Team</a>.')
        }
        let data = this.route.parent.parent.snapshot.data,
            parentParentData = this.route.parent.parent.parent.parent.snapshot.data;

        this.offers = data['suppliers'];
        this.contract = data['contract'];
        this.tender = parentParentData['tender'];
        this.rounds = data['rounds'];
        this.round = this.contract.currentRound;

        this.filterPlattsIndexes();
    }

    public isSubmittedBid() {
        return !!(this.offers.filter(item => item.bid ? item.bid : 0)).length;
    }

    private filterPlattsIndexes() {
        let plattsChartIndexes = [];

        this.offers.forEach(item => {
            if (item.bid && item.bid.plattsIndexPrice) {
                plattsChartIndexes.push({
                    id: item.bid.plattsIndexPrice.index.id,
                    bateId: item.bid.plattsIndexPrice.bates.id,
                    offers: item // index details block
                });
                this.plattsChartIndexes = plattsChartIndexes;
            }
        })
    }
}
